<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="name">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="status">
                <wbo-entity-availability-single-select-search-control [activeName]="'enabled'"
                                                                      [inactiveName]="'disabled'"></wbo-entity-availability-single-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="activeOnDate">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column field="name"></wbo-main-search-column>
        <wbo-checkbox-column field="enabled" [sortable]="false"></wbo-checkbox-column>
        <wbo-checkbox-column field="showAsVenueStatus"></wbo-checkbox-column>
        <wbo-actions-search-column>
            <wbo-delete-search-action></wbo-delete-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
